import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OceanLineModel } from '../../services/index';

@Component({
  selector: 'data-selector',
  templateUrl: 'data-selector.html'
})
export class DataSelectorComponent implements OnDestroy{
  @Input() except: Array<string>;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onCheckExistData: EventEmitter<any> = new EventEmitter();
  @Input() filterCd: string;
  @Input() filterNm: string;
  @Input() id: string;
  @Input() index: number;
  @Input() label: string;
  @Input() filterFunc: (data: any, keyword:string) => boolean;
  @Input() setValueFuc: (data: any) => string;

  @Input() set isDisabled(isDisabled:boolean){
    if(!isDisabled) return;
    this.selectorControl.disable();
  }

  // 조회 리스트
  _list: Array<any> = new Array();
  @Input() set list(list){ 
    if(!list) return; 
    this._list = list; 
    
    //selectedCd가 먼저 입력되고 List가 없어서 찾지 못했을 경우를 위해서 set
    if(this._selectedCd != null){
      this.selectedCd = this._selectedCd;
    }
  }
  get list(){ return this._list; }

  //리스트에서 선택한 값
  selectedData: any;


  _selectedCd:string;
  @Input() set selectedCd(selectedCd){ 
    if(!selectedCd) return; 
    this._selectedCd = selectedCd; 
    this.checkInput();
  }
  get selectedCd(){ return this._selectedCd; }

  
  
  isOpen:boolean = false;
  filteredDataList: Array<any> = [];
  focusedIndex: number;
  selectorControl: FormControl  = new FormControl();


  @ViewChild("dataList")
  dataListRef: ElementRef;


  constructor(
  ) {}

  ngOnInit() {
    
  }

  setValue(data:any){
    if (this.setValueFuc) return this.setValueFuc(data);

    if(this.filterCd){
      return data[this.filterNm] + ' (' + data[this.filterCd] + ')';
    }else{
      return data[this.filterNm];
    }
  }

  checkInput() {
    
    let temp = _.map(_.filter(this.list,
      (data) => {
        if (this.id != null && this.id != undefined &&  String(data[this.id]).indexOf(this.selectedCd) > -1) return true;
        if (this.filterCd != null && this.filterCd != undefined && String(data[this.filterCd]).indexOf(this.selectedCd) > -1) return true;
        else return false;
    }));

    if(temp != null && temp.length > 0){
      this.selectedData = temp[0]; 
      if(this.selectedData) this.selectorControl.setValue(this.setValue(this.selectedData));
    }

    // if(this.except != null && this.except.length == 1) {
    //   let exceptIndex = _.findIndex(this.list, {lineCd: this.except});
    //   this.list.splice(exceptIndex, 1);  
    // } else if(this.except != null && this.except.length > 1) {
    //   for(let lineCd of this.except) {
    //     let exceptIndex = _.findIndex(this.list, {lineCd: lineCd});
    //     this.list.splice(exceptIndex, 1);
    //   };
    // } else {
    //   return;
    // }
  }

  click(event){

    let keyword = event.target.value;
    if(keyword){
      this.setFilteredList(event);
    }else{
      this.filteredDataList = this.list;
     
      this.isOpen = true;
      this.focusedIndex =  0;   
    }   
  }

  setFilteredList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      if (this.selectedData) this.selectedData = null;
      
      if(this.index == null || this.index == undefined){
        this.onSelect.emit(null);
      }else{
        this.onSelect.emit({data:null, index:this.index});
      }
      this.isOpen = false;
      return;
    }

    if(this.list == null || this.list.length < 1){
      this.onCheckExistData.emit(false);
    }
    
    if(keyword.length > 0) {
      keyword = _.toUpper(keyword);
		  let tempDataList = _.map(_.filter(this.list,
																	(data) => {
                                    if (this.filterFunc) return this.filterFunc(data, keyword);
																		if (keyword.length <= 0) return true;
                                    else if (this.filterCd != null && this.filterCd != undefined && _.toUpper(data[this.filterCd]).indexOf(keyword) >= 0) return true;
																		else if (_.toUpper(data[this.filterNm]).indexOf(keyword) >= 0) return true;
																		else return false;
                                  }));
      
      this.filteredDataList = _.sortBy(tempDataList,
																(data) => {
																	let nmIndex = _.toUpper(data[this.filterCd]).indexOf(keyword);
																	let cdIndex = _.toUpper(data[this.filterNm]).indexOf(keyword);
																	if (nmIndex < 0) nmIndex = 999;
																	if (cdIndex < 0) cdIndex = 999;
																	return _.min([nmIndex, cdIndex])
                                });
                                
      this.isOpen = true;
      this.focusedIndex =  0;    
    } else {
      this.isOpen = false;
    }
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

    suggestListDom = this.dataListRef.nativeElement;
    focusedIndex = this.focusedIndex;
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (_.isEmpty(this.filteredDataList) || !this.focusedIndex == null || !this.isOpen) return;
        let item = this.filteredDataList[this.focusedIndex];
        this.selectHandler(item);
        this.isOpen = false;
			  break;
			case 27: // escape
					this.isOpen = false;
          
          if (this.selectedData) this.selectorControl.setValue(this.setValue(this.selectedData));
          
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }	
    if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
    event.preventDefault();
  }

  handleBlur($event) {
    if (this.isOpen) this.isOpen = false;

    if (this.selectedData && $event.target.value) {
      this.selectorControl.setValue(this.setValue(this.selectedData));
    } else {
      this.selectorControl.setValue(null);
    }
  }

  selectHandler(data) {
    this.isOpen = false;
    this.selectedData = data;
    
    if(this.selectedData != null) {
      this.selectorControl.setValue(this.setValue(this.selectedData));
      if(this.index == null || undefined){
        this.onSelect.emit(this.selectedData);
      }else{
        this.onSelect.emit({data:this.selectedData, index:this.index});
      }
    }
  }

  close(){
    this.selectorControl = new FormControl();
    this.selectedData = null;
  }

  ngOnDestroy(){

  }

}


// WEBPACK FOOTER //
// ./src/app/components/selector/data-selector.ts